import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'config/axiosConfig';
import { PropertyStatisticsActionEnum } from 'types/PropertyStatistics';

interface PublicSavePropertyStatisticsRequest {
    webPageId: string;
    action: PropertyStatisticsActionEnum;
}

const savePublicPropertyStatistics = async (data: PublicSavePropertyStatisticsRequest): Promise<number> => {
    const response = await axiosInstance.post('/properties/public/save-statistic', data);
    return response.status;
};

export const usePublicSavePropertyStatistics = () => {
    return useMutation({
        mutationFn: savePublicPropertyStatistics,
    });
};
